module.exports = __webpack_public_path__ + "static/media/filled_open_spot_icon.fac0eac9.svg";